﻿import controller from '../../../../Resources/Scripts/_Shared/Controller';
import { paramsToObject } from '../../../../Resources/Scripts/_Shared/history'
import { createFocusTrap } from 'focus-trap';

function myaimoparkoverlay(context) {
  let requestAnimation = false;
  const htmlElement = document.querySelector('html');
  const contentWrapper = context.querySelector('[data-overlay-content]');
  const persistMarkup = context.querySelector('[data-persist-markup');

  function init() {
    initMaxHeight();
    window.addEventListener('resize', initMaxHeight);
    window.addEventListener('orientationchange', initMaxHeight);

    context.addEventListener('click', function(event) {
      if (event.target.dataset.closeOverlay) {
        closeOverlay(context);
			}
    });
  }

  function initMaxHeight() {
    if (!requestAnimation) {
      window.requestAnimationFrame(function() {
        context.style.maxHeight = `${window.innerHeight}px`;
        requestAnimation = false;

				//if (window.innerWidth > 1164) {
        //  htmlElement.classList.remove('map-overlay-active');
        //  context.style.removeProperty('max-height');

        //  window.removeEventListener('resize', initMaxHeight);
        //  window.removeEventListener('orientationchange', initMaxHeight);
				//}
      });
    }

    requestAnimation = false;
	}

  return {
    init
  };
}

export function appendContent(context, data, html = '') {
  const contentWrapper = context.querySelector('[data-overlay-content]');

	if (html) {
    contentWrapper.innerHTML = html;
    context.removeAttribute('aria-busy');

    controller.parse(contentWrapper);
	} else if (data && data.error) {
    context.removeAttribute('aria-busy');
	}
}

export function openOverlay(context, data = {}) {

  const htmlElement = document.querySelector('html');
  htmlElement.classList.add('map-overlay-active');

  const contentWrapper = context.querySelector('[data-overlay-content]');
  const headingContainer = context.querySelector('header h1');
  const subHeadingContainer = context.querySelector('header h2');

  if (data.clearContent)
    contentWrapper.innerHTML = '';

  if (data.heading)
    headingContainer.innerHTML = data.heading;

  if (data.subHeading)
    subHeadingContainer.innerHTML = data.subHeading;

  if (data.hideLoader === null || data.hideLoader === undefined || data.hideLoader === false)
    context.setAttribute('aria-busy', 'true');

  context.setAttribute('aria-hidden', 'false');

  window.focusTrap = createFocusTrap(context);
  window.focusTrap.activate();
}

export function closeOverlay(context, data = {}) {
  const htmlElement = document.querySelector('html');
  htmlElement.classList.remove('map-overlay-active');

  context.setAttribute('aria-hidden', 'true');
  context.removeAttribute('aria-busy');

  const urlParams = new URLSearchParams(window.location.search);
  const reload = urlParams.has('reload');

  urlParams.delete('reload');
  urlParams.delete('permitId');
  urlParams.delete('waitingListId');
  urlParams.delete('requestId');

  let newUrl = window.location.origin + window.location.pathname;
  if (urlParams.toString().length > 0)
    newUrl += '?' + urlParams.toString()

  history.replaceState(paramsToObject(urlParams), document.title, newUrl);

  if(window.focusTrap)
    window.focusTrap.deactivate();
  
  setTimeout(function () {
    const headingContainer = context.querySelector('header h1');
    const subHeadingContainer = context.querySelector('header h2');
    const contentWrapper = context.querySelector('[data-overlay-content]');

    headingContainer.innerHTML = '';
    subHeadingContainer.innerHTML = '';

    if ((data.persistMarkup === false) || (typeof persistMarkup !== 'undefined' && persistMarkup && persistMarkup === 'false'))
      contentWrapper.innerHTML = '';

    if (reload) location.reload();
  }, 500);
}

controller.add('myaimopark-overlay', myaimoparkoverlay);